import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store'
import ReservationLogin from '@/views/ReservationLogin.vue'
import ReservationOptions from '@/views/ReservationOptions.vue'
import ReservationFlights from '@/views/ReservationFlights.vue'
import ReservationPassengers from '@/views/ReservationPassengers.vue'
import ReservationRevision from '@/views/ReservationRevision.vue'
import ReservationCancellation from '@/views/ReservationCancellation.vue'

const router = createRouter({
  history: createWebHashHistory(),

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash && document.querySelector(to.hash)) {
      return { el: to.hash }
    }

    return { top: 0 }
  },

  routes: [
    {
      path: '/',
      redirect: '/reservation-options',
      component: ReservationOptions
    },
    {
      path: '/reservation-options',
      component: ReservationOptions,
      // meta: { requiresAuth: true }
    },
    {
      path: '/reservation-flights',
      component: ReservationFlights,
      // meta: { requiresAuth: true }
    },
    {
      path: '/reservation-passengers',
      component: ReservationPassengers,
      // meta: { requiresAuth: true }
    },
    {
      path: '/reservation-revision',
      component: ReservationRevision,
      // meta: { requiresAuth: true }
    },
    {
      path: '/reservation-cancellation',
      name: 'reservation-cancellation',
      component: ReservationCancellation,
      meta: { public: true }
    }
  ]
})

// router.beforeEach(( to, from, next ) => {
//   const isLoggedIn = store.state.loginModule.userLoginStatus
//
//   if( !to.meta.public && to.meta.requiresAuth && !isLoggedIn ) {
//     next('/')
//     return
//   }
//
//   if( to.path === '/' && isLoggedIn ) {
//     next( '/reservation-options' )
//     return
//   }
//
//   next()
// })

export default router